export default function () {
  return {
    leases: [],
    leasesLoading: false,
    // Lease selected in non lease pages (eg, budget / summary)
    selectedLease: {},
    // Full lease details fetched for a lease instance
    lease: {},
    leaseLoading: false,
    // Flag indicating that the user has leases. Can become a getter based on
    // the leases variable
    hasLeases: false,
    // A map of lease IDs that have had their dashboard delivery message shown
    deliveryMessageShown: {}
  };
}
